import React, { useState} from "react";
import Menu from "../../../components/layout/menu/index"
import error403 from "../../../assets/images/errorPages/error403.svg"
import ErrorPage from "../../../components/shared/errorPages";

export default function Error403() {

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <div>
        <Menu isPageError={true} isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
        <ErrorPage
        title="Acceso restringido"
        description="El acceso a este recurso está restringido.
Por favor, regrese a la página anterior."
        errorImage={error403}
        onClick={() => window.history.back()}
        />
    </div>
  )
}